/* e6be3bbdccf46ee31cd4c3cab083815064322822
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SliderBannersQueryVariables = Types.Exact<{
  location?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SliderBannersQuery = { __typename?: 'Query', sliderBanners?: { __typename?: 'BannerItems', items?: Array<{ __typename?: 'Banner', app_image_url?: string | null, background_color?: string | null, image?: string | null, banner_id?: number | null, image_app?: string | null, image_mobile?: string | null, position?: string | null, name?: string | null, url_banner?: string | null } | null> | null } | null };

export type CategoryBannersQueryVariables = Types.Exact<{
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  type?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CategoryBannersQuery = { __typename?: 'Query', categoryBanners?: { __typename?: 'CategoryBanners', items?: Array<{ __typename?: 'Banner', app_image_url?: string | null, background_color?: string | null, banner_id?: number | null, image?: string | null, image_app?: string | null, image_mobile?: string | null, name?: string | null, position?: string | null, url_banner?: string | null } | null> | null } | null };

export type HomepageFloatBannerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomepageFloatBannerQuery = { __typename?: 'Query', homepageFloatBanner?: { __typename?: 'HomePageFloatBanner', left_banner_img?: string | null, left_banner_url?: string | null, right_banner_img?: string | null, right_banner_url?: string | null } | null };


export const SliderBannersDocument = gql`
    query SliderBanners($location: String) {
  sliderBanners(location: $location) {
    items {
      app_image_url
      background_color
      image
      banner_id
      image_app
      image_mobile
      position
      name
      url_banner
    }
  }
}
    `;

/**
 * __useSliderBannersQuery__
 *
 * To run a query within a React component, call `useSliderBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSliderBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSliderBannersQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useSliderBannersQuery(baseOptions?: Apollo.QueryHookOptions<SliderBannersQuery, SliderBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SliderBannersQuery, SliderBannersQueryVariables>(SliderBannersDocument, options);
      }
export function useSliderBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SliderBannersQuery, SliderBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SliderBannersQuery, SliderBannersQueryVariables>(SliderBannersDocument, options);
        }
export function useSliderBannersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SliderBannersQuery, SliderBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SliderBannersQuery, SliderBannersQueryVariables>(SliderBannersDocument, options);
        }
export type SliderBannersQueryHookResult = ReturnType<typeof useSliderBannersQuery>;
export type SliderBannersLazyQueryHookResult = ReturnType<typeof useSliderBannersLazyQuery>;
export type SliderBannersSuspenseQueryHookResult = ReturnType<typeof useSliderBannersSuspenseQuery>;
export type SliderBannersQueryResult = Apollo.QueryResult<SliderBannersQuery, SliderBannersQueryVariables>;
export const CategoryBannersDocument = gql`
    query CategoryBanners($categoryId: Int, $type: String) {
  categoryBanners(category_id: $categoryId, type: $type) {
    items {
      app_image_url
      background_color
      banner_id
      image
      image_app
      image_mobile
      name
      position
      url_banner
    }
  }
}
    `;

/**
 * __useCategoryBannersQuery__
 *
 * To run a query within a React component, call `useCategoryBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryBannersQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCategoryBannersQuery(baseOptions?: Apollo.QueryHookOptions<CategoryBannersQuery, CategoryBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryBannersQuery, CategoryBannersQueryVariables>(CategoryBannersDocument, options);
      }
export function useCategoryBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryBannersQuery, CategoryBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryBannersQuery, CategoryBannersQueryVariables>(CategoryBannersDocument, options);
        }
export function useCategoryBannersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CategoryBannersQuery, CategoryBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryBannersQuery, CategoryBannersQueryVariables>(CategoryBannersDocument, options);
        }
export type CategoryBannersQueryHookResult = ReturnType<typeof useCategoryBannersQuery>;
export type CategoryBannersLazyQueryHookResult = ReturnType<typeof useCategoryBannersLazyQuery>;
export type CategoryBannersSuspenseQueryHookResult = ReturnType<typeof useCategoryBannersSuspenseQuery>;
export type CategoryBannersQueryResult = Apollo.QueryResult<CategoryBannersQuery, CategoryBannersQueryVariables>;
export const HomepageFloatBannerDocument = gql`
    query HomepageFloatBanner {
  homepageFloatBanner {
    left_banner_img
    left_banner_url
    right_banner_img
    right_banner_url
  }
}
    `;

/**
 * __useHomepageFloatBannerQuery__
 *
 * To run a query within a React component, call `useHomepageFloatBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageFloatBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageFloatBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomepageFloatBannerQuery(baseOptions?: Apollo.QueryHookOptions<HomepageFloatBannerQuery, HomepageFloatBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepageFloatBannerQuery, HomepageFloatBannerQueryVariables>(HomepageFloatBannerDocument, options);
      }
export function useHomepageFloatBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepageFloatBannerQuery, HomepageFloatBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepageFloatBannerQuery, HomepageFloatBannerQueryVariables>(HomepageFloatBannerDocument, options);
        }
export function useHomepageFloatBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomepageFloatBannerQuery, HomepageFloatBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomepageFloatBannerQuery, HomepageFloatBannerQueryVariables>(HomepageFloatBannerDocument, options);
        }
export type HomepageFloatBannerQueryHookResult = ReturnType<typeof useHomepageFloatBannerQuery>;
export type HomepageFloatBannerLazyQueryHookResult = ReturnType<typeof useHomepageFloatBannerLazyQuery>;
export type HomepageFloatBannerSuspenseQueryHookResult = ReturnType<typeof useHomepageFloatBannerSuspenseQuery>;
export type HomepageFloatBannerQueryResult = Apollo.QueryResult<HomepageFloatBannerQuery, HomepageFloatBannerQueryVariables>;